/**
 * Sessão do comprador (Fase 7): token JWT (jose, assinado no backend) salvo
 * no localStorage, mandado como `Authorization: Bearer` — sem Clerk, sem
 * cookie (evita CSRF por natureza: o header só é enviado por JS same-origin,
 * nunca automaticamente pelo browser). Escopado por incorporadora (`slug`),
 * já que o mesmo navegador pode logar em apps de incorporadoras diferentes.
 */

function chave(slug: string): string {
  return `ama_comprador_sessao_${slug}`;
}

export function salvarSessaoComprador(slug: string, token: string): void {
  localStorage.setItem(chave(slug), token);
}

export function sessaoCompradorAtual(slug: string): string | null {
  return localStorage.getItem(chave(slug));
}

export function limparSessaoComprador(slug: string): void {
  localStorage.removeItem(chave(slug));
}
